import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import App from './App';
import Auth from './Auth';
import Billing from './Billing';
import Catalog from './Catalog';
import Analytics from './Analytics';
import Recs from './Recs';
import Search from './Search';
import Settings from './Settings';
import Notifications from './Notifications';
import OnboardingSlice from '../slices/OnboardingSlice';
import BridgeSlice from '../slices/BridgeSlice';
import WizardSlice from '../slices/WizardSlice';
import FiltersSlice from '../slices/FiltersSlice';
import SynonymsSlice from '../slices/SynonymsSlice';
import FieldsSlice from '../slices/FieldsSlice';
import FacetValuesSlice from '../slices/FacetValuesSlice';
import TaxonomiesSlice from '../slices/TaxonomiesSlice';
import SuggestionOverridesSlice from '../slices/SuggestionOverridesSlice';
import SettingsPreviewSlice from '../slices/SettingsPreviewSlice';
import SettingsV2Slice from '../slices/settingsV2Slice';
import CatalogSyncSlice from '../slices/catalogSyncSlice';
import AnalyticsSlice from '../slices/AnalyticsSlice';
import EmptyQuerySlice from '../slices/EmptyQuerySlice';
import ProductSelectorSlice from '../slices/ProductSelectorSlice';
import { searchExperienceReducer } from '../features/search-experience-v2';
import MerchandisingSlice from '../features/merchandising/state/merchandisingSlice';
import wizardReducer from '../features/wizard/wizardSlice';

export default (history) => combineReducers({
  router: connectRouter(history),
  app: App,
  auth: Auth,
  billing: Billing,
  catalog: Catalog,
  catalogSync: CatalogSyncSlice,
  analytics: Analytics,
  recs: Recs,
  search: Search,
  settings: Settings,
  notifications: Notifications,
  onboarding: OnboardingSlice,
  bridge: BridgeSlice,
  wizard: WizardSlice,
  integrationWizard: wizardReducer,
  filters: FiltersSlice,
  synonyms: SynonymsSlice,
  fields: FieldsSlice,
  facetValues: FacetValuesSlice,
  taxonomies: TaxonomiesSlice,
  suggestionOverrides: SuggestionOverridesSlice,
  settingsPreview: SettingsPreviewSlice,
  settingsV2: SettingsV2Slice,
  analyticsSearch: AnalyticsSlice,
  emptyQuery: EmptyQuerySlice,
  productSelector: ProductSelectorSlice,
  searchExperience: searchExperienceReducer,
  merchandising: MerchandisingSlice,
});
